import { AxiosError } from 'axios';
import get from 'lodash/get';
import isArray from 'lodash/isArray';
import isEmpty from 'lodash/isEmpty';
import isString from 'lodash/isString';

export const getApiErrorMessage = (error: AxiosError | any) => {
  const data = get(error, ['response', 'data']);
  if (isString(data)) {
    return data || 'Unknown Error';
  }

  if (isString(data?.error)) {
    return data?.error;
  }

  const responseMessage = get(error, ['response', 'data', 'message']);

  if (isArray(responseMessage) && isString(responseMessage?.[0])) {
    return responseMessage?.[0];
  }

  if (isString(responseMessage) && !isEmpty(responseMessage)) {
    return responseMessage;
  }

  const message = get(error, ['message']);
  if (isString(message) && !isEmpty(message)) {
    return message;
  }
  return 'Unknown Error';
};

export const getBlobErrorMessage = async (error: AxiosError | any) => {
  const data = get(error, ['response', 'data']);
  if (isString(data)) {
    return data;
  }

  if (data instanceof Blob) {
    const message = await data.text();
    if (isString(message)) {
      return message;
    }
  }
  const responseMessage = get(error, ['response', 'data', 'message']);
  if (isArray(responseMessage) && isString(responseMessage?.[0])) {
    return responseMessage?.[0];
  }

  if (isString(responseMessage) && !isEmpty(responseMessage)) {
    return responseMessage;
  }

  const message = get(error, ['message']);
  if (isString(message) && !isEmpty(message)) {
    return message;
  }
  return 'Unknown Error';
};
